import { Checkbox, Chip, FormControl, Radio, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import { ICustomTheme } from 'interfaces';

/** Enlarged Radio button for quiz choices */
export const StyledChoiceRadio = styled(Radio)(
  ({ theme }: { theme: ICustomTheme }) => ({
    '& .MuiSvgIcon-root': {
      fontSize: 28,
    },
    padding: theme.spacing(0.75, 1),
  }),
);

/** Enlarged Checkbox for quiz choices */
export const StyledChoiceCheckbox = styled(Checkbox)(
  ({ theme }: { theme: ICustomTheme }) => ({
    '& .MuiSvgIcon-root': {
      fontSize: 28,
    },
    padding: theme.spacing(0.75, 1),
  }),
);

/** Half-width FormControl wrapping the dropdown Select */
export const StyledDropdownFormControl = styled(FormControl)(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),
);

/** Style object for the Select input display area */
export const selectDisplayStyle = { padding: '10.5px 14px' } as const;

/** Greyed-out placeholder rendered inside the Select */
export const StyledSelectPlaceholder = styled('em')(() => ({
  color: 'rgba(0,0,0,0.38)',
  fontSize: 16,
}));

/** Flex container for the chips of selected dropdown values */
export const StyledSelectedChipsWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap' as const,
  gap: 4,
  marginTop: 8,
}));

/** Individual chip showing a selected choice */
export const StyledChoiceChip = styled(Chip)(() => ({
  fontSize: 16,
}));

/** Hint caption rendered below the dropdown in multi-choice mode */
export const StyledDropdownChoicesHint = styled(Typography)(() => ({
  marginTop: 4,
}));

/** Choice label text used inside Radio / Checkbox FormControlLabel */
export const StyledChoiceLabel = styled('span')(() => ({
  fontSize: 16,
}));

/** Hint caption rendered above checkboxes in multi-choice mode */
export const StyledCheckboxChoicesHint = styled(Typography)(() => ({
  marginBottom: 4,
}));
